import { Outlet, useOutletContext } from 'react-router-dom'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import EmployeeList from 'modules/timeoff/components/TimeoffPolicy/EmployeeList'
import { PolicyDetailTabs } from 'modules/timeoff/components/TimeoffPolicy/PolicyDetailTabs'
import type { RouteContextParams } from 'modules/timeoff/lib/routeContextParams'

const EmployeeListPage = () => {
  const { tabs, policy, loading } = useOutletContext<RouteContextParams>()

  return (
    <ResponsivePage.Body loading={loading} error={null}>
      <PolicyDetailTabs tabs={tabs} />
      <EmployeeList timeoffPolicyId={policy?.attributes.id}>
        <Outlet />
      </EmployeeList>
    </ResponsivePage.Body>
  )
}

export default EmployeeListPage
